// Skeleton — shimmer placeholder for loading states.
//
//   <Skeleton width="60%" height={20} />
//   <Skeleton.Row count={5} />     // 5 stacked rows for tables/lists
//   <Skeleton.Card height={140} /> // single card-shaped block

import React from 'react';

const base = {
  background: 'linear-gradient(90deg, #eef2f7 25%, #f7f9fc 37%, #eef2f7 63%)',
  backgroundSize: '400% 100%',
  borderRadius: 4,
  animation: 'skeleton-shimmer 1.4s ease infinite',
};

const Skeleton = ({ width = '100%', height = 12, style = {} }) => (
  <div style={{ ...base, width, height, ...style }} />
);

Skeleton.Row = ({ count = 3, gap = 10 }) => (
  <div style={{ display: 'flex', flexDirection: 'column', gap }}>
    {Array.from({ length: count }, (_, i) => (
      <div key={i} style={{ display: 'flex', gap: 10 }}>
        <Skeleton width={32} height={32} style={{ borderRadius: 6 }} />
        <div style={{ flex: 1, display: 'flex', flexDirection: 'column', gap: 6 }}>
          <Skeleton width="40%" height={12} />
          <Skeleton width="80%" height={10} />
        </div>
      </div>
    ))}
  </div>
);

Skeleton.Card = ({ height = 100 }) => (
  <Skeleton width="100%" height={height} style={{ borderRadius: 12 }} />
);

Skeleton.Tile = () => (
  <div className="stat-card">
    <Skeleton width={52} height={52} style={{ borderRadius: 12 }} />
    <div style={{ flex: 1, display: 'flex', flexDirection: 'column', gap: 8 }}>
      <Skeleton width={70} height={28} />
      <Skeleton width={120} height={10} />
    </div>
  </div>
);

export default Skeleton;
